import { makeStyles } from '@material-ui/core'

export default makeStyles({
  title: {
    fontFamily: 'Yu Gothic',
    fontSize: 28,
    fontWeight: 'bold',
    padding: '5px 10px',
    color: 'rgba(0,0,0,0.85)',
    backgroundColor: 'rgba(0,0,0,0)',
  },
  grid: {
    width: 'auto',
  },
  icon: {
    color: 'rgba(0,0,0,0.85)',
    padding: '7px 0px 0px',
  },
})
